// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1ZvnH","inputWrap":"Table_inputWrap__1HtyK","col":"Table_col__1ovnw","bmiTooltip":"Table_bmiTooltip__3jMQi"};